import { render } from "./CommunityBoard.vue?vue&type=template&id=499d1aca"
import script from "./CommunityBoard.vue?vue&type=script&lang=js"
export * from "./CommunityBoard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommunityBoard.vue?vue&type=style&index=0&id=499d1aca&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__